import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { VerificationCallResponse } from "../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { logger } from "providers/logger";

const generateVerificationCallUrl = async (
  prospectId: string,
  language: "en" | "es" = "en"
) => {
  return await AmplifyPost<VerificationCallResponse>(
    "Generate Verification Call Url",
    "OfferExpApi",
    `/prospect/${prospectId}/generateVerificationCallUrl`,
    { body: { language } },
    logger
  );
};

export { generateVerificationCallUrl };
